import { Control } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import type { ExamFormData } from '../utils/examValidation';

interface EyeAssessmentProps {
  control: Control<ExamFormData>;
}

export function EyeAssessment({ control }: EyeAssessmentProps) {
  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="rightEye"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Right Eye Vision (20/x)</FormLabel>
            <FormControl>
              <Input type="number" {...field} onChange={e => field.onChange(Number(e.target.value))} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="leftEye"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Left Eye Vision (20/x)</FormLabel>
            <FormControl>
              <Input type="number" {...field} onChange={e => field.onChange(Number(e.target.value))} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}